// @core/api/endpoints/secret/revoke_certificate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CertificateResponse,
  RevokeCertificateRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Revoke certificate
 * Revokes a certificate by serial number. The certificate is added to the CRL and its status is set to REVOKED.
 */
export async function RevokeCertificate(
  engine_id: string,
  data: RevokeCertificateRequest,
  options?: RequestOptions
): Promise<CertificateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/revoke`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = options;
  return client.post<CertificateResponse>(requestPath, data, requestOptions);
}
